module.exports = __webpack_public_path__ + "static/img/menuPomoc-OFF.7ebe19af.png";